/*
----------------------------------------------------------------------------
Usage:
----------------------------------------------------------------------------
import AnchorLinksToggle from './modules/anchor-links-toggle'
_('anchor-links-toggle').nodes().map((el) => new AnchorLinksToggle(el))
----------------------------------------------------------------------------
Attributes:
----------------------------------------------------------------------------
data-behaviour="anchor-links-toggle"    - For setting up the click event
data-element="anchor-link"            - For targeting the element
data-class="trigger-class"       - active class (optional)
*/

import { removeClasses, _ } from '../utils.js'
import Sticky from './sticky.js'

class AnchorLinksToggle {
    constructor(el) {
        this.el = el
        this.listContainer = _('anchor-nav-container', 'element').nodeFrom(el)
        this.list = _('anchor-nav-list', 'element').nodeFrom(el)
        this.anchorLinks = _('anchor-link', 'element').nodesFrom(el)
        this.controls = _('control', 'element').nodesFrom(el)
        this.trigger = _('scroll-x-trigger', 'element').nodesFrom(el)
        this.prev = el.querySelector(
            '[data-element="scroll-x-trigger"][data-type="prev"]',
        )
        this.next = el.querySelector(
            '[data-element="scroll-x-trigger"][data-type="next"]',
        )
        this.activeClass = this.el.dataset.class
        this.isSticky = this.el.dataset.sticky === 'sticky'
        this.offset = this.el.offsetTop

        if (this.isSticky) {
            if (window.innerWidth > 728) {
                this.el.classList.add('sticky')
                new Sticky(this.el)
            }
        }

        this.anchorLinks.map((link) => {
            link.addEventListener('click', this.goToAnchor)
        })

        this.trigger.map((trigger) => {
            trigger.addEventListener('click', this.scrollX)
        })

        this.list.addEventListener('scroll', this.toggleButtons)
        this.toggleButtons()

        if (this.isSticky) {
            _('sticky')
                .nodes()
                .forEach((stickyElement) => {
                    stickyElement.classList.add('sticky--removed')
                })
        }

        this.list.addEventListener('scroll', this.manualScroll)

        this.triggerAnchor()
    }

    goToAnchor = (e) => {
        history.pushState(null, null, e.currentTarget.getAttribute('href'))
        this.triggerAnchor()
    }

    triggerAnchor = () => {
        if (window.location.hash === '' || !this.anchorLinks.length) {
            return false
        }

        this.anchorLinks.map((el) => {
            if (el.getAttribute('href') === window.location.hash) {
                this.toggleAnchorLinkClass(el)
            }
        })
    }

    toggleAnchorLinkClass = (e) => {
        if (e.classList.contains(this.activeClass)) {
            return false
        }

        removeClasses(this.anchorLinks, this.activeClass)
        e.classList.add(this.activeClass)
    }

    scrollX = (e) => {
        this.type = e.currentTarget.dataset.type
        const clientWidth = this.listContainer.clientWidth
        const leftOffset = this.list.scrollLeft

        if (this.type === 'prev') {
            this.width = leftOffset - clientWidth
        }
        if (this.type === 'next') {
            this.width = leftOffset + clientWidth
        }

        this.list.scrollTo({
            left: this.width,
            behavior: 'smooth',
        })
    }

    hideAllButtons = () => {
        this.controls.map((control) => {
            control.classList.add('u-hidden')
        })
    }

    toggleButtons = () => {
        const clientWidth = this.listContainer.clientWidth
        const scrollableWidth = this.list.scrollWidth
        const leftOffset = this.list.scrollLeft
        const rightOffset = clientWidth + leftOffset
        const scrollableOffset = 1
        if (clientWidth >= scrollableWidth) {
            this.hideAllButtons()
        } else {
            // scrolled fully to the left (with a bit of leeway)
            if (leftOffset > 5) {
                this.prev.parentNode.classList.remove('u-hidden')
            } else {
                this.prev.parentNode.classList.add('u-hidden')
            }

            // scrolled to the end
            if (rightOffset + scrollableOffset < scrollableWidth) {
                this.next.parentNode.classList.remove('u-hidden')
            } else {
                this.next.parentNode.classList.add('u-hidden')
            }
        }
    }
}

export default AnchorLinksToggle